/* eslint-disable react/jsx-no-bind, consistent-return, react/jsx-closing-tag-location */
import LoadingSpinner from "../BuyItNow/components/LoadingSpinner";
import NonMemberCartAPI from "../../shared/modules/NonMemberCartAPI";
import Notification from "../../shared/components/Notification";
import PropTypes from "prop-types";
import React from "react";

const AddToCartButton = ({isItemAvailable, productDescriptor, showClearancePrice}) => {
  const [
    notificationText,
    setNotificationText
  ] = React.useState(null);
  const [
    isLoading,
    setIsLoading
  ] = React.useState(false);

  React.useEffect(() => {
    if (notificationText) {
      const timeout = setTimeout(() => {
        setNotificationText(null);
      }, 6000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [notificationText]);


  const handleAddToCart = () => {
    setIsLoading(true);
    const storeKind = showClearancePrice ? "clearance" : "retail";
    NonMemberCartAPI.addToCart(productDescriptor.id, 1, storeKind).then((response) => {
      if (response.error) {
        setNotificationText(response.error);
      } else {
        setNotificationText("Added to cart");
      }
      setIsLoading(false);
    });
  };

  const buttonText = isItemAvailable ? "Add to Cart" : "Out of Stock";

  return (
    <div>
      {notificationText &&
        <Notification
          modalClassAddition="flex"
          modalHideSpeed={4000}
          notificationDisplayText={notificationText}
        />
      }
      <button
        className="btn btn-primary wide centered mt8"
        disabled={isLoading || !isItemAvailable}
        onClick={handleAddToCart}
        type="button"
      >
        {isLoading ? <div style={{"padding": "5.355px"}}>
          <LoadingSpinner />
        </div> : buttonText}
      </button>
    </div>
  );
};

AddToCartButton.propTypes = {
  "cookies": PropTypes.object.isRequired,
  "isItemAvailable": PropTypes.bool.isRequired,
  "productDescriptor": PropTypes.object.isRequired,
  "showClearancePrice": PropTypes.bool.isRequired
};

export default AddToCartButton;
